import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=b5be3408&scoped=true"
import script from "./MenuDetail.vue?vue&type=script&lang=js"
export * from "./MenuDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5be3408",
  null
  
)

export default component.exports